export default __webpack_public_path__ + "static/media/virtual-tour-slide-4-tablet.fe8358b9.png";